import {
  AppWindow,
  Briefcase,
  Bug,
  Building2,
  Calendar,
  Camera,
  CircleHelp,
  Cloud,
  CreditCard,
  Database,
  FileText,
  FingerprintPattern,
  FolderOpen,
  GamepadDirectional,
  Globe,
  HardDrive,
  Headset,
  Key,
  Keyboard,
  Landmark,
  Laptop,
  Layers2,
  Lock,
  Mail,
  MessageSquare,
  Monitor,
  Package,
  Phone,
  Presentation,
  Printer,
  Server,
  Settings,
  Shield,
  Smartphone,
  Truck,
  Users,
  Wifi,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  Database,
  AppWindow,
  Layers2,
  Printer,
  Monitor,
  FolderOpen,
  Globe,
  Smartphone,
  Wifi,
  Mail,
  Landmark,
  GamepadDirectional,
  Presentation,
  FingerprintPattern,
  Laptop,
  Server,
  HardDrive,
  Cloud,
  Phone,
  Headset,
  MessageSquare,
  Users,
  Settings,
  Wrench,
  Bug,
  Shield,
  Lock,
  Key,
  Keyboard,
  Camera,
  FileText,
  CreditCard,
  Briefcase,
  Building2,
  Calendar,
  Package,
  Truck,
  Zap,
  CircleHelp,
};

export const CATEGORY_ICON_NAMES = Object.keys(ICONS);

export function categoryIcon(name?: string | null): LucideIcon {
  return (name && ICONS[name]) || FolderOpen;
}
